import { gql } from "@apollo/client";

export const GET_APPOINTMENTS_BY_DATE = gql`
  query getDiagnosisAppointmentByDate(
    $listFilter: listFilterInput!
    $date: String!
    $filterBy: scanFilterStatus
  ) {
    getDiagnosisAppointmentByDate(
      listFilter: $listFilter
      date: $date
      filterBy: $filterBy
    ) {
      data {
        id
        patientName
        doctorName
        appointmentPaymentMode
        patientMobileNumber
        paymentStatus
        appointmentStartTime
        appointmentEndTime
        latestStatus
        testProductType
        testProductId
        isConsumerAppointment
        patientId
        doctorId
        labRoomName
        reportUrl
        labRoomId
        scanTestDetails {
          testGroupName
          testGroupId
          testName
          testNameId
          price
        }
      }
      total
      pageSize
      page
      totalPages
    }
  }
`;

export const CANCEL_APPOINTMENT = gql`
  mutation cancelAppointment($id: ID!, $cancelInput: cancelInput) {
    cancelAppointment(id: $id, cancelInput: $cancelInput)
  }
`;


   // field: $field
      // value: $value
      // date: $date
      // productType: $productType

       // $field: String
    // $value: String
    // $date: String
    // $productType: String   

export const GET_FILTERED_APPOINTMENTS = gql`
  query getDiagnosisAppointmentByStatus(
    $listFilter: listFilterInput!
    $appointmentStatus: String!
    $searchQuery: searchQueryInput
  ) {
    getDiagnosisAppointmentByStatus(
      listFilter: $listFilter
      appointmentStatus: $appointmentStatus
      searchQuery: $searchQuery
    ) {
      data {
        id
        receiptNo
        patientName
        patientMobileNumber
        doctorName
        paymentStatus
        appointmentStartTime
        reportUrl
        latestStatus
        testProductType
        scanTestDetails {
          testGroupName
          testGroupId
          testName
          testNameId
          price
          unit
          maleLowerRange
          maleUpperRange
          femaleLowerRange
          femaleUpperRange
        }
      }
      total
      pageSize
      page
      totalPages
    }
  }
`;

export const GET_APPOINTMENTDETAILS = gql`
  query getDiagnosisAppointmentDetailById($id: ID) {
    getDiagnosisAppointmentDetailById(id: $id) {
      id
      patientName
      patientMobileNumber
      doctorName
      receiptUrl
      appointmentStartTime
      appointmentEndTime
      latestStatus
      outstandingAmount
      createdDate
      netAmount
      receiptNo
      labRoomName
      labRoomId
      gender
      businessProfile {
        businessName
        businessAddresses {
          street
          city
          district
          state
          country
          zipCode
        }
      }
      scanTestDetails {
        testGroupName
        testDetails {
          testName
          testNameId
          testGroupId
          price
          maleLowerRange
          maleUpperRange
          femaleLowerRange
          femaleUpperRange
          unit
        }
      }
      paymentDetails {
        paymentStatus
        paymentMode
        cashIn
        cashOut
        totalAmount
        transactionAmount
        outstandingBalance
        transactionDate
      }
    }
  }
`;

export const CREATE_REPORT = gql`
  mutation createDiagnosisResult($resultInput: resultInput!) {
    createDiagnosisResult(resultInput: $resultInput)
  }
`;

export const UPDATE_APPOINTMENT_STATUS = gql`
  mutation updateDiagnosisAppointmentStatus(
    $id: ID!
    $appointmentStatus: String!
  ) {
    updateDiagnosisAppointmentStatus(
      id: $id
      appointmentStatus: $appointmentStatus
    )
  }
`;

export const GET_TEST_RESULTS = gql`
  query getTestResultDetailByAppointmentId($id: ID!) {
    getTestResultDetailByAppointmentId(id: $id) {
      reportUrl
      totalOutstandingAmount
      testDetails {
        testGroupInfo {
          testGroupLabel
        }
        testPrice {
          price
        }
        testName
        resultValue
        unit
        testId

        testInfo {
          price
          maleLowerRange
          femaleLowerRange
          maleUpperRange
          femaleUpperRange
        }
      }
    }
  }
`;
